import HotelsAPIFactory from './hotelsAPI';
import HotelsFactory from './hotelsFactory';
import HotelsOptionsFactory from './hotelsOptions';

const MODULE_NAME = 'App.Hotels.hotel-factory';
const module = angular
    .module(MODULE_NAME, [])
    .factory('hotelsAPI', HotelsAPIFactory)
    .factory('hotelsFactory', HotelsFactory)
    .factory('hotelsOptions', HotelsOptionsFactory);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/hotels/services/hotels-factory-module.js